import { Docket, OrderType, OrderTypeCode } from '@oolio-group/domain';
import { CourseStatus } from '../../common/constants';

function filterDockets(
  filter: CourseStatus | undefined,
  dockets: Docket[],
  orderTypes: OrderType[],
): Docket[] {
  const dineInOrderTypeId = orderTypes.find(
    orderType => orderType.code === OrderTypeCode.DINE_IN,
  )?.id;

  if (!dineInOrderTypeId) {
    return [];
  }

  if (filter === CourseStatus.AWAY) {
    return dockets
      .filter(
        docket =>
          docket.orderType?.id === dineInOrderTypeId &&
          docket.docketItems.some(item => {
            if (!item.course?.id) return true; // Items without courseId go with AWAY (NOW Course)
            if (!item.course?.callInfo) return false; // Items with courseId but no callInfo go with HOLD
            return item.course.callInfo.isCalled === true;
          }),
      )
      .map(docket => ({
        ...docket,
        docketItems: docket.docketItems.filter(item => {
          if (!item.course?.id) return true; // Items without courseId go with AWAY (NOW Course)
          if (!item.course?.callInfo) return false; // Items with courseId but no callInfo go with HOLD
          return item.course.callInfo.isCalled === true;
        }),
      }));
  }
  if (filter === CourseStatus.HOLD) {
    return dockets
      .filter(
        docket =>
          docket.orderType?.id === dineInOrderTypeId &&
          docket.docketItems.some(item => {
            if (!item.course?.id) return false; // Items without courseId go with AWAY (NOW Course)
            if (!item.course?.callInfo) return true; // Items with courseId but no callInfo go with HOLD
            return item.course.callInfo.isCalled !== true;
          }),
      )
      .map(docket => ({
        ...docket,
        docketItems: docket.docketItems.filter(item => {
          if (!item.course?.id) return false; // Items without courseId go with AWAY (NOW Course)
          if (!item.course?.callInfo) return true; // Items with courseId but no callInfo go with HOLD
          return item.course.callInfo.isCalled !== true;
        }),
      }));
  }
  return dockets;
}

function filterDocketsByOrderId(orderId: string, dockets: Docket[]): Docket[] {
  return dockets.filter(docket => docket.orderId === orderId);
}

export { filterDockets, filterDocketsByOrderId };
